import React, { Component } from "react";
import { PageHeader } from "antd";
import { Tabs } from "antd5";
import Manuales from "./Manuales/Manuales";
import Tutoriales from "./Tutoriales/Tutoriales";
import {
  BookOutlined,
  PlayCircleOutlined,
  EditOutlined
} from "@ant-design/icons";
import { connect } from "react-redux";
import Blog from "./Blog/Blog";

class Soporte extends Component {
  render() {
    const tabItems = [
      {
        label: (
          <span>
            <EditOutlined />
            Blog
          </span>
        ),
        key: "1",
        children: <Blog/>
      },
      {
        label: (
          <span>
            <BookOutlined />
            Manuales
          </span>
        ),
        key: "2",
        children: <Manuales/>
      },
      {
        label: (
          <span>
            <PlayCircleOutlined />
            Tutoriales
          </span>
        ),
        key: "3",
        children: <Tutoriales/>
      },
    ]

    return (
      <>
        <PageHeader
          title="Soporte"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{backgroundColor: 'white', padding: 20, paddingTop: 5}}>
          <Tabs defaultActiveKey="1" items={tabItems} />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Soporte);